import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ pages }) => {
  return (
    <nav className="flex mb-6" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li>
          <div>
            <Link
              to="/"
              className="text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 text-sm font-medium"
            >
              Dashboard
            </Link>
          </div>
        </li>
        {pages.map((page, index) => (
          <li key={page.name} className="inline-flex items-center">
            <ChevronRightIcon
              className="h-5 w-5 text-gray-600 dark:text-gray-400 mx-1"
              aria-hidden="true"
            />
            {page.href ? (
              <Link
                to={page.href}
                className="ml-1 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
              >
                {page.name}
              </Link>
            ) : (
              <span className="ml-1 text-sm font-medium text-gray-600 dark:text-gray-400" aria-current="page">
                {page.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;